
export class NameAddress {

    constructor() { }

    public RefID: string;
    public AddressID: string;

    public AddrID: string;
    public JurisID: number;
    public NameID: string;
    public Address1: string;
    public Address2: string;
    public Premise: string;
    public City: string;
    public State: string;
    public Zip: string;
    public Latitude?: number;
    public Longitude?: number;
    public CreatedPFID: string;
    public CreatedDttmUTC: Date;
    public ModifiedPFID: string;
    public ModifiedDttmUTC: Date;
    public AptNo: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/nameaddress.model.ts